define('widgets/dgrid/blocks/reelRacesBig/reelRacesBig',[
    'underscore',
    'knockout'
], function (_, ko) {

    var ReelRacesBig = function (tournamentCampaignsViewModel, getFields, ReelRacesHowItWorksDialog, dialog, player) {
        var self = this;

        var activeCampaign = tournamentCampaignsViewModel.activeCampaign();
        var hasParticipatedBefore = ko.observable(player().rawPlayerTournamentCampaignData() ?
                player().rawPlayerTournamentCampaignData().hasParticipatedInTournaments :
                false);

        self.background = getFields('background_image');
        self.logo = getFields('logo');
        self.backgroundColor = getFields('background_color');

        self.nextTournament = activeCampaign.nextTournament;
        self.startTime = ko.pureComputed(function() {
            return self.nextTournament() ? self.nextTournament().startTime : null;
        });
        self.title = self.nextTournament() ? self.nextTournament().title() : null;

        self.participated = {
            description: ko.pureComputed(function() {
                return self.nextTournament() ? self.nextTournament().info() : null
            }),
            headline: ko.pureComputed(function() {
                return self.nextTournament() ? self.nextTournament().firstPrize() : null
            }),
            buttonText: ko.pureComputed(function() {
                return self.nextTournament() ? self.nextTournament().joinButtonText() : null
            }),
            cta: ko.pureComputed(function() {
                return self.nextTournament() ? self.nextTournament().joinTournament : null
            })
        };

        self.notParticipated = {
            headline: getFields('headline'),
            description: getFields('description'),
            buttonText: getFields('cta_text'),
            cta: function () {
                dialog.showDialog(new ReelRacesHowItWorksDialog());
            }
        };

        self.startingIn = getFields('start_in');

        self.buttonText = ko.pureComputed(function() {
            return hasParticipatedBefore() ? self.participated.buttonText() : self.notParticipated.buttonText();
        });

        self.headline = ko.pureComputed(function() {
           return hasParticipatedBefore() ? self.participated.headline() : self.notParticipated.headline();
        });

        self.description = ko.pureComputed(function() {
            return hasParticipatedBefore() ? self.participated.description() : self.notParticipated.description();
        });

        self.cta = ko.pureComputed(function() {
            return hasParticipatedBefore() ? self.participated.cta()() : self.notParticipated.cta();
        });
    };

    ReelRacesBig.prototype.activate = function(settings) {
        var self = this;

        self.activateFallback = settings.activateFallback;

        self.nextTournament.subscribeAndExec(function() {
            return self.activateFallback(_.isNaN(self.nextTournament()));
        });
    };

    return ReelRacesBig;
});

